module.exports = __webpack_public_path__ + "img/cutlet.781988f1.png";